import React from 'react'
import { Link } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { getColorByStationName } from '../../../helpers/common'
import {
  flatNames,
  getNumberOfOffers,
} from '../../../helpers/getNumberOfOffers'
import { Container } from '../../Container/Container'
import { CarIcon } from '../../icons/CarIcon'
import { WalkMan } from '../../icons/WalkMan'
import styles from './informationBlock.module.scss'
import { InformationBlockType } from './informationBlock.types'

export const InformationBlock = ({
  shortName,
  address,
  readyPeriod,
  presentReady,
  cnt,
  prices,
  projectUrl,
  presentNotReady,
  id,
}: InformationBlockType) => {
  return (
    <div className={styles.informationBlock}>
      <Container>
        <div className={styles.infoContainer}>
          <h2 className={styles.infoTitle}>{shortName}</h2>

          <div className={styles.infoItems}>
            {address.UF_METRO_NAME && (
              <div className={styles.infoItem}>
                <div
                  className={styles.metroItem}
                  style={{
                    background: getColorByStationName(address.UF_METRO_NAME),
                  }}
                />
                <p>{address.UF_METRO_NAME}</p>
                {address.UF_METRO_TIME_ON_FOOT !== null && (
                  <div className={styles.metroItem__row}>
                    <WalkMan />
                    <p>{`${address.UF_METRO_TIME_ON_FOOT} мин`}</p>
                  </div>
                )}
                {address.UF_METRO_TIME_ON_TRANSPORT !== null && (
                  <div className={styles.metroItem__row}>
                    <CarIcon />
                    <p>{`${address.UF_METRO_TIME_ON_TRANSPORT} мин`}</p>
                  </div>
                )}
              </div>
            )}

            {prices.from && (
              <div
                className={`${styles.infoItem} ${styles['infoItem--for-desktop']}`}
              >
                <p>от {prices.from} млн ₽</p>
              </div>
            )}

            {(presentNotReady || presentReady) && (
              <div
                className={`${styles.infoItem} ${styles['infoItem--for-desktop']}`}
              >
                <p>
                  {presentNotReady && `Сдача в ${readyPeriod}`}
                  {presentNotReady && presentReady ? ', ' : ''}
                  {presentReady && 'есть сданные'}
                </p>
              </div>
            )}

            {cnt && (
              <div className={styles.infoItem}>
                <p>
                  {cnt.split('').slice(-1)[0] === '1' ? 'Осталась' : 'Осталось'}{' '}
                  {getNumberOfOffers(Number(cnt), flatNames)}
                </p>
              </div>
            )}
          </div>

          {projectUrl && (
            <Link
              to={`/flats/${id}`}
              className={styles.infoButton}
              onClick={() => {
                ym('reachGoal', 'choose a flat', {
                  'project page': {
                    'choose a flat': shortName,
                  },
                })
              }}
            >
              Выбрать квартиру
            </Link>
          )}
        </div>
      </Container>
    </div>
  )
}
